<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t('message.Apks') }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t('message.Главная') }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t('message.Apks') }}</li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper">
      <b-button
        :variant="'success'"
        class="mb-1 float-right"
        @click="addRow()"
      >{{ $t('message.Apk_Добавить') }}</b-button>
      <b-table
            id="apk-table"
            :busy.sync="isBusy"
            :items="dataProvider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template slot="actions" slot-scope="row">
              <b-button
                size="sm"
                @click.stop="editRow(row.item, row.index, $event.target)"
                class="mr-1">
                <i class="fas fa-edit"></i>
              </b-button>
              <b-button 
                size="sm" 
                @click.stop="deleteRow(row.item, row.index, $event.target)">
                <i class="fas fa-trash-alt"></i>
              </b-button>
            </template>

      </b-table>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"></b-pagination>

      <b-modal
        id="modalInfo"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Apk_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-esc
        no-close-on-backdrop
      >
        <ApkForm :model="apkModel"></ApkForm>
      </b-modal>

    </div>
</div>
</template>

<script>
import ApkForm from "./ApkForm";
import Vue from "vue";

export default {
  name: "Apks",
  components: {
    ApkForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id",            sortable: true },
        { key: "build",         sortable: true },
        { key: "version",       sortable: false },
        { key: "description",   sortable: false, thStyle: "width:20%;" },
        { key: "enabled",       sortable: false },
        { key: "ips_only",      sortable: false },
        { key: "ips_exclude",   sortable: false },
        { key: "ips_list",      sortable: false },
        { key: "ips_re_only",   sortable: false },
        { key: "ips_re_exclude",sortable: false },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      apkModel: {},
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
    };
  },
  created: function() {
  },
  methods: {
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("apks", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false

          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      this.apkModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_запись?"))
        .then(response => {
          this.$noname
            .delete("apks", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "apk-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });

              //window.location.href = redirectUrl
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    },
    addRow() {

      this.apkModel = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },    
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (this.apkModel.id > 0) {
        this.$noname
          .patch("apks", this.apkModel.id, this.apkModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "apk-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("apks", this.apkModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "apk-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Apks.vue